import { GetterTree } from 'vuex'
import { IRootState, IShoppingCartState } from '@/@types'
import CONSTANTS from '@/constants'

const getters: GetterTree<IShoppingCartState, IRootState> = {
  selectedPlan: state => {
    const { PLANS } = CONSTANTS
    const planCodesWithoutSkillDive = Object.values(PLANS).filter(
      planId => planId !== PLANS.SKILL_DIVE_ANNUAL
    )
    return (
      state.shoppingCart.find(
        item => item.merchant_id && planCodesWithoutSkillDive.includes(item.merchant_id)
      ) || {}
    )
  },
  selectedSkillDivePlan: state => {
    const { PLANS } = CONSTANTS
    const cartHasSkillDive = state.shoppingCart.find(
      item => item.merchant_id === PLANS.SKILL_DIVE_ANNUAL
    )
    return cartHasSkillDive || {}
  },
}

export default getters
